(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Controller = App.loadClass('core::Angular/Controller');

  exports.SidebarController = (function(superClass) {
    extend(SidebarController, superClass);

    function SidebarController(scope, transitions, Steps, state, loader, http, location, fields, validation) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.loader = loader;
      this.http = http;
      this.location = location;
      this.fields = fields;
      this.validation = validation;
      this.makeSteps = bind(this.makeSteps, this);
      this.getStepNumbersByMode = bind(this.getStepNumbersByMode, this);
      this.findStepsByLayerTitle = bind(this.findStepsByLayerTitle, this);
      this.loadIds = bind(this.loadIds, this);
      this.exitProcess = bind(this.exitProcess, this);
      this.step = bind(this.step, this);
      this.enableSteps = bind(this.enableSteps, this);
      this.loadIrrigationZone = bind(this.loadIrrigationZone, this);
      this.routeDataView = bind(this.routeDataView, this);
      this.routeAddCrop = bind(this.routeAddCrop, this);
      this.routeIrrigationAdd = bind(this.routeIrrigationAdd, this);
      this.routeDataAdd = bind(this.routeDataAdd, this);
      this.routeStep = bind(this.routeStep, this);
      this.fireValidation = bind(this.fireValidation, this);
      this.previousStep = bind(this.previousStep, this);
      this.initializeFieldData = bind(this.initializeFieldData, this);
      this.start = bind(this.start, this);
      this.initializeSteps = bind(this.initializeSteps, this);
      this.initializeTextObject = bind(this.initializeTextObject, this);
      this.initializeDisabledObject = bind(this.initializeDisabledObject, this);
      this.init = bind(this.init, this);
      this.initVariables = bind(this.initVariables, this);
      this.initValidation = bind(this.initValidation, this);
      this.setupForNewProcess = bind(this.setupForNewProcess, this);
      this.cleanup = bind(this.cleanup, this);
      SidebarController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.show_fullpage = false;
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          var ref;
          if (((ref = _this.scope.field_data) != null ? ref.boundary_layer : void 0) != null) {
            App.map.removeLayer(_this.scope.field_data.boundary_layer);
          }
          _this.validation.checkBoundary();
          return _this.cleanup();
        };
      })(this));
      this.init(Steps);
    }

    SidebarController.prototype.cleanup = function() {
      delete this.scope.field_data;
      delete this.scope.steps;
      this.fields_id = void 0;
      this.year = void 0;
      this.layer_id = void 0;
      this.fields.cleanup();
      return this.validation.cleanup();
    };

    SidebarController.prototype.setupForNewProcess = function() {
      var ref;
      if (((ref = this.validation.settings) != null ? ref.process_mode : void 0) == null) {
        this.validation.cleanup();
        this.validation.settings = {
          process_mode: 'zone-add'
        };
      }
      return this.validation.setupByMode();
    };

    SidebarController.prototype.initValidation = function() {
      this.validation.setFieldsData();
      return this.validation.setProcessMode();
    };

    SidebarController.prototype.initVariables = function() {
      this.process_mode = this.validation.process_mode;
      this.scope.fireValidation = this.fireValidation;
      this.scope.previousStep = this.previousStep;
      this.fields_id = this.fields.getFieldsId();
      this.year = this.fields.getYear();
      return this.layer_id = this.fields.getLayersId();
    };

    SidebarController.prototype.init = function(Steps) {
      this.setupForNewProcess();
      this.initValidation();
      this.initVariables();
      this.initializeDisabledObject();
      this.initializeTextObject();
      return this.initializeFieldData().then((function(_this) {
        return function() {
          _this.initializeSteps(Steps);
          _this.validation.setMainScope(_this.scope);
          return _this.start();
        };
      })(this));
    };

    SidebarController.prototype.initializeDisabledObject = function() {
      var ref;
      this.scope.disabled = {
        next: true,
        required: false,
        back: false
      };
      if ((ref = this.process_mode) === 'zone-add' || ref === 'irrigation-add' || ref === 'zone-edit' || ref === 'add-crop') {
        return this.scope.disabled.back = true;
      }
    };

    SidebarController.prototype.initializeTextObject = function() {
      return this.scope.text = {
        next: 'Next',
        back: 'Back',
        required: 'Required *'
      };
    };

    SidebarController.prototype.initializeSteps = function(Steps) {
      this.scope.steps = Steps["new"]();
      this.scope.steps.setScope(this.scope);
      this.scope.steps.setEventPrefix('grower.fields-define');
      this.scope.steps.setExitCallback(this.exitProcess);
      return this.scope.steps.setSteps(this.makeSteps(this.process_mode));
    };

    SidebarController.prototype.start = function() {
      var step;
      step = this.state.$current.name;
      return this.routeStep(step);
    };

    SidebarController.prototype.initializeFieldData = function() {
      return this.loadIds().then((function(_this) {
        return function(ids) {
          var irrigation_mdc_id, previous_crop_mdc_id, productivity_mdc_id;
          irrigation_mdc_id = ids[0], previous_crop_mdc_id = ids[1], productivity_mdc_id = ids[2];
          _this.scope.field_data = {
            name: null,
            farm: null,
            boundary: null,
            id: _this.fields_id,
            process_mode: _this.process_mode,
            year: _this.year,
            getAcres: function() {
              return 0;
            },
            zone_unique_id: 0,
            zones: {
              'irrigation': {
                zones: [],
                map_data_categories_id: irrigation_mdc_id
              },
              'previous-crop': {
                zones: [],
                map_data_categories_id: previous_crop_mdc_id
              },
              'productivity': {
                zones: [],
                map_data_categories_id: productivity_mdc_id
              }
            },
            zone_steps: [
              {
                name: 'Irrigation',
                enabled: false,
                child_steps: ['grower.fields-define.irrigation-draw', 'grower.fields-define.irrigation-settings1', 'grower.fields-define.irrigation-settings2']
              }, {
                name: 'Previous Crop',
                enabled: false,
                child_steps: ['grower.fields-define.previous-crop-draw', 'grower.fields-define.previous-crop-settings1']
              }, {
                name: 'Productivity',
                enabled: false,
                child_steps: ['grower.fields-define.productivity-draw', 'grower.fields-define.productivity-settings1', 'grower.fields-define.productivity-settings2']
              }
            ],
            final_step: 'grower.fields-define.finish'
          };
          return _this.fields.hasFieldprintAccess().then(function(response) {
            if (response.data.data) {
              _this.scope.field_data.has_fieldprint_access = true;
              return _this.scope.field_data.zone_steps[0].child_steps.push('grower.fields-define.irrigation-details');
            }
          });
        };
      })(this));
    };

    SidebarController.prototype.previousStep = function() {
      if (this.scope.steps.activeStep.state === 'grower.fields-define.locate') {
        return this.state.go('grower.fields');
      } else {
        this.validation.wentBack();
        return this.scope.steps.gotoPrevStep();
      }
    };

    SidebarController.prototype.fireValidation = function(ending) {
      this.scope.$evalAsync((function(_this) {
        return function() {
          return _this.scope.disabled.next = true;
        };
      })(this));
      if (!this.validation.wait_before_next_step) {
        this.scope.steps.gotoNextStep();
      }
      return this.validation.validate(ending);
    };

    SidebarController.prototype.routeStep = function(step) {
      if (step === 'grower.fields-define') {
        this.scope.field_data.editing = true;
        this.fields.setFieldData(this.scope.field_data);
        if (this.process_mode === 'zone-add') {
          this.routeDataAdd();
        }
        if (this.process_mode === 'irrigation-add') {
          this.routeIrrigationAdd();
        }
        if (this.process_mode === 'zone-edit') {
          this.routeDataView();
        }
        if (this.process_mode === 'add-crop') {
          return this.routeAddCrop();
        }
      } else {
        return this.step(step);
      }
    };

    SidebarController.prototype.routeDataAdd = function() {
      var cb, ref, ref1;
      cb = (function(_this) {
        return function() {
          return _this.step('grower.fields-define.select-management-zones');
        };
      })(this);
      if ((((ref = this.validation.settings) != null ? ref.year : void 0) != null) && (((ref1 = this.validation.settings) != null ? ref1.fid : void 0) != null)) {
        return this.loadIrrigationZone().then((function(_this) {
          return function() {
            return _this.fields.zones.hasExistingPreviousCropZone(_this.validation.settings.fid, _this.validation.settings.year).then(function(response) {
              _this.scope.field_data.zones['previous-crop'].has_existing = response.data.data;
              return _this.fields.load(cb);
            });
          };
        })(this));
      } else {
        return this.fields.load(cb);
      }
    };

    SidebarController.prototype.routeIrrigationAdd = function() {
      var cb, ref, ref1;
      cb = (function(_this) {
        return function() {
          var step;
          _this.scope.field_data.zone_steps[0].enabled = true;
          step = _this.enableSteps(_this.scope.field_data, true);
          return _this.step(step);
        };
      })(this);
      if ((((ref = this.validation.settings) != null ? ref.year : void 0) != null) && (((ref1 = this.validation.settings) != null ? ref1.fid : void 0) != null)) {
        return this.loadIrrigationZone().then((function(_this) {
          return function() {
            return _this.fields.load(cb);
          };
        })(this));
      } else {
        return this.fields.load(cb);
      }
    };

    SidebarController.prototype.routeAddCrop = function() {
      var cb;
      cb = (function(_this) {
        return function(result) {
          var step;
          _this.scope.field_data.zone_steps[0].enabled = true;
          step = _this.enableSteps(_this.scope.field_data, true, true);
          return _this.step(step);
        };
      })(this);
      return this.loadIrrigationZone().then((function(_this) {
        return function() {
          _this.fields.fields_id = _this.validation.settings.fid;
          return _this.fields.load(cb);
        };
      })(this));
    };

    SidebarController.prototype.routeDataView = function() {
      var cb;
      cb = (function(_this) {
        return function(result) {
          var step;
          step = _this.enableSteps(result, true);
          return _this.step(step);
        };
      })(this);
      return this.fields.load(cb, 'single', this.fields.layers_id);
    };

    SidebarController.prototype.loadIrrigationZone = function() {
      return this.fields.zones.getIrrigationZoneByFieldYear(this.validation.settings.fid, this.validation.settings.year).then((function(_this) {
        return function(response) {
          if (response.data.data) {
            _this.scope.field_data.zones.irrigation = response.data.data;
            _this.scope.field_data.zones.irrigation.zones = [];
            return _this.scope.field_data.zones.irrigation.loaded_zones = response.data.data.areas;
          }
        };
      })(this));
    };

    SidebarController.prototype.enableSteps = function(data, return_first_enabled, skip_first_two_zone_steps) {
      var child_step, i, j, len, len1, needs_set, ref, ref1, zone_steps;
      if (return_first_enabled == null) {
        return_first_enabled = false;
      }
      if (skip_first_two_zone_steps == null) {
        skip_first_two_zone_steps = false;
      }
      needs_set = true;
      ref = data.zone_steps;
      for (i = 0, len = ref.length; i < len; i++) {
        zone_steps = ref[i];
        if (zone_steps.enabled === true) {
          ref1 = zone_steps.child_steps;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            child_step = ref1[j];
            if (child_step === 'grower.fields-define.irrigation-details') {
              if (this.scope.field_data.has_fieldprint_access) {
                this.scope.steps.enableStep(child_step);
              } else {
                continue;
              }
            } else if ((child_step === 'grower.fields-define.irrigation-draw' || child_step === 'grower.fields-define.irrigation-settings1') && skip_first_two_zone_steps) {
              continue;
            } else {
              this.scope.steps.enableStep(child_step);
            }
            if (return_first_enabled && needs_set === true) {
              needs_set = child_step;
            }
          }
        }
      }
      return needs_set;
    };

    SidebarController.prototype.step = function(step) {
      return this.scope.steps.gotoStep(step);
    };

    SidebarController.prototype.exitProcess = function() {
      return this.state.go('grower');
    };

    SidebarController.prototype.loadIds = function() {
      return this.http.post('backend/grower/fields/define/load-zone-mdc-ids').then((function(_this) {
        return function(response) {
          var irrigation_id, k, previous_crop_id, productivity_id, ref, v;
          irrigation_id = null;
          productivity_id = null;
          previous_crop_id = null;
          ref = response.data.data;
          for (k in ref) {
            v = ref[k];
            if (k === 'Irrigation') {
              irrigation_id = v;
            }
            if (k === 'Productivity') {
              productivity_id = v;
            }
            if (k === 'Previous Crop') {
              previous_crop_id = v;
            }
          }
          return [irrigation_id, previous_crop_id, productivity_id];
        };
      })(this));
    };

    SidebarController.prototype.findStepsByLayerTitle = function() {
      if (/Productivity.*/.test(this.validation.settings.layers_title)) {
        return [11, 12, 13, 14];
      }
      if (/Irrigation.*/.test(this.validation.settings.layers_title)) {
        return [5, 6, 7, 8, 14];
      }
      if (this.validation.settings.layers_title === 'Previous Crop') {
        return [9, 10, 14];
      }
      if (/Previous Crop.*/.test(this.validation.settings.layers_title)) {
        return [9, 10, 14];
      }
    };

    SidebarController.prototype.getStepNumbersByMode = function(mode) {
      switch (mode) {
        case 'zone-edit':
          return this.findStepsByLayerTitle();
        case 'zone-add':
          return [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
        case 'irrigation-add':
          return [5, 6, 7, 8, 14];
        case 'add-crop':
          return [7, 8, 14];
      }
    };

    SidebarController.prototype.makeSteps = function(mode) {
      var i, len, number, result, steps, steps_numbers_to_add, stp;
      steps_numbers_to_add = this.getStepNumbersByMode(mode);
      result = [];
      steps = [
        {
          state: 'grower.fields-define.locate'
        }, {
          state: 'grower.fields-define.identify'
        }, {
          state: 'grower.fields-define.clus'
        }, {
          state: 'grower.fields-define.boundary'
        }, {
          state: 'grower.fields-define.select-management-zones'
        }, {
          state: 'grower.fields-define.irrigation-draw',
          disabled: true
        }, {
          state: 'grower.fields-define.irrigation-settings1',
          disabled: true
        }, {
          state: 'grower.fields-define.irrigation-settings2',
          disabled: true
        }, {
          state: 'grower.fields-define.irrigation-details',
          disabled: true
        }, {
          state: 'grower.fields-define.previous-crop-draw',
          disabled: true
        }, {
          state: 'grower.fields-define.previous-crop-settings1',
          disabled: true
        }, {
          state: 'grower.fields-define.productivity-draw',
          disabled: true
        }, {
          state: 'grower.fields-define.productivity-settings1',
          disabled: true
        }, {
          state: 'grower.fields-define.productivity-settings2',
          disabled: true
        }, {
          state: 'grower.fields-define.finish'
        }
      ];
      for (number = i = 0, len = steps.length; i < len; number = ++i) {
        stp = steps[number];
        if (indexOf.call(steps_numbers_to_add, number) >= 0) {
          if (stp.state === 'grower.fields-define.irrigation-details') {
            if (this.scope.field_data.has_fieldprint_access) {
              result.push(stp);
            }
          } else {
            result.push(stp);
          }
        }
      }
      return result;
    };

    return SidebarController;

  })(Controller);

}).call(this);
